import React, { useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import CommonBtn from '../../components/global/CommonBtn'
import { formatCardNumber, formatMobile } from '../../components/global/FormatString'
import { encryptionHandler, formatYearMonthExpiry, getPartnerDetails, isTimeBeforeCurrentFacilityTime, isUserLoggedIn, getLocalFacilityId, getDeviceType, getFormattedAmountNumber, hostedCardTokenFields, restrictInputValues, validExpiryDate } from '../../utils/helper'
import { EMPTY_OBJECT, EVENT_TYPES, EMPTY_ARRAY, errorMessages, PAYMENT_GATEWAY, getWalletScriptUrl, usesHostedCardFields } from '../../constants/globalConstants'
import { dynamicPaymentGateByNonce } from '../../redux/actions/booking'
import { useCaptchaService } from '../../services/captchaService'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { Circles } from 'react-loader-spinner'
import URL from '../../constants/urls'
import { globalKeyStore } from '../../redux/actions/globalState'
import moment from 'moment'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import PaymentMethodModal from '../../components/global/PaymentMethodModal'
import PaymentGatewayCommon from '../paymentForm/PaymentGatewayCommon'
import WalletButtons from '../../components/walletButtons'
import CardConnectTokenizer, { waitForCardTokenizer } from '../../components/walletButtons/CardTokenizer'
import { completeStripeRequiredAction, getStripeRequiredAction, isStripeGateway, STRIPE_CAPTURE } from '../../components/stripe/stripeClient'
import { getStripeErrorMessage } from '../../components/stripe/stripeErrors'
import { addScript } from '../../utils/addScript'

const cardNumberMask = createDefaultMaskGenerator('9999 9999 9999 9999')
const cardExpiryMask = createDefaultMaskGenerator('99/99')

function ConfirmationPage({
    allFacility, prevFormStep, dispatch, isLoader, userDetails, selectedFacilityId, selectedCard, notify,
    cardToken, cardList
}) {

    let linkFacility = []
    allFacility?.length > 0 ? allFacility.map((v) => {
        linkFacility.push(v?.id)
    }) : null
    let linkFacilityId = linkFacility.join(',')

    const navigate = useNavigate()
    const captchaService = useCaptchaService()
    const { facility, independant_pass_id, event_id } = useParams()
    const [localIsBookingClosed, setLocalIsBookingClosed] = useState(false)

    const { pathname } = useLocation()
    const partnername = pathname?.split('/')?.filter(v => v != '')

    const bookingData = JSON.parse(localStorage.getItem('bookingFormDetail')) ? JSON.parse(localStorage.getItem('bookingFormDetail')) : {}
    // const userDataLoc = JSON.parse(localStorage.getItem('userData'))
    const { personal_info, payment_detail, get_event_type, event_data, sessionDetails, user_consent, payment_profile_id, vehicle_details } = (bookingData) ? bookingData : EMPTY_OBJECT
    const { name, email, phone } = (personal_info) ? personal_info : EMPTY_OBJECT
    const { card_pan, card_date_expiry_month, card_date_expiry_year, card_card_security_cvx_2, zipcode } = (payment_detail) ? payment_detail : EMPTY_OBJECT
    const phone_number = formatMobile(phone)
    const card = card_pan ? formatCardNumber(card_pan) : selectedCard?.card_last_four ? formatCardNumber('000000000000' + selectedCard?.card_last_four) : ''

    // EOS-5655: never send an event booking without the event / price / partner it belongs to
    const isEventBooking = get_event_type == EVENT_TYPES?.EVENT && isNaN(independant_pass_id)
    const bookingAmount = sessionDetails?.data?.amount
    const isBookingDataMissing = (isEventBooking && (!event_data?.id || !event_data?.parking_start_time))
        || bookingAmount === undefined || bookingAmount === null || bookingAmount === ''
        || !getPartnerDetails()?.id

    // blocks repeat clicks while reCAPTCHA / payment request is in flight
    const submittingRef = useRef(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        const updatedDetails = {
            ...bookingData,
            personal_info: { name: (userDetails?.name) ? userDetails?.name : name, email: (userDetails?.email) ? userDetails?.email : email, phone: (userDetails?.phone_number) ? userDetails?.phone_number : phone },
        }
        localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
    }, [isUserLoggedIn()])


    useEffect(() => {
        if (!personal_info) {
            navigate(`/${partnername?.[0]}`)
            navigate(0)
        }
    }, [])

    // payment: from the payment modal ({ kind: 'token' | 'nonce' | 'saved' | 'wallet' | 'verify', ... }); none = as before
    const onClickSubmit = (payment = null) => {
        if (submittingRef.current) return
        if (isBookingDataMissing) {
            notify('error', errorMessages?.eventSessionExpired)
            return
        }
        const eventTypeLoc = localStorage.getItem('selectEventType')
        let encryptCardData = ''

        const selLocalFacilityId = facility ? facility : JSON.parse(localStorage?.getItem('selectedFacilityId'))

        const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId

        let selectEventLinkFacility = eventTypeLoc == 'pass' ? localStorage?.getItem('passData') ? JSON.parse(localStorage?.getItem('passData'))?.facility : {} : localStorage?.getItem('selectEventLinkFacility') ? JSON.parse(localStorage?.getItem('selectEventLinkFacility')).find((v) => v?.id == eventFacilityid) : {}
        console.log(selectEventLinkFacility)
        if (selectEventLinkFacility?.facility_payment_details?.facility_payment_type_id == '3') {
            let card = {
                name_on_card: name ? name : '',
                card_number: cardToken?.token || '',
                expiration_date: formatYearMonthExpiry(cardToken?.expiry),
                security_code: '',
            }
            if (cardToken?.zip_code) {
                card.zip_code = cardToken?.zip_code
            }
            encryptCardData = encryptionHandler(card)
        } else {
            const encryptedPayload = {
                name_on_card: (name) ? name : '',
                card_number: (card_pan) ? card_pan : '',
                expiration_date: `${(card_date_expiry_month) ? card_date_expiry_month : ''}${(card_date_expiry_year) ? card_date_expiry_year : ''}`,
                // Above change has a BE Dependancy, Ask Ujjwal sir
                security_code: (card_card_security_cvx_2) ? card_card_security_cvx_2 : '',
                zip_code: zipcode || ''
            }

            if (encryptedPayload?.expiration_date == '' && encryptedPayload?.card_number == '') {
                encryptCardData = ''
            } else if ((encryptedPayload?.expiration_date && encryptedPayload?.card_number)) {
                encryptCardData = encryptionHandler(encryptedPayload)
            }
        }

        if (selLocalFacilityId || selectedFacilityId) {
            localStorage.setItem('urlHistory', JSON.stringify(window.location.href))
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            let finalPayload = {}
            const partnerDetails = getPartnerDetails()
            let selectEventLinkFacility = eventTypeLoc == 'pass' ? localStorage?.getItem('passData') ? JSON.parse(localStorage?.getItem('passData'))?.facility : {} : localStorage?.getItem('selectEventLinkFacility') ? JSON.parse(localStorage?.getItem('selectEventLinkFacility')).find((v) => v?.id == eventFacilityid) : {}
            let facilityTimeZone = selectEventLinkFacility?.timezone ? selectEventLinkFacility?.timezone : 'America/New_York'
            let currentTime = moment().tz(facilityTimeZone).format('YYYY-MM-DD hh:mm:ss')
            let isParkingStartPassed = moment(event_data?.parking_start_time).isBefore(currentTime)
            let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(event_data?.stop_event_booking_time, facilityTimeZone)
            if ((get_event_type !== EVENT_TYPES?.EVENT && eventTypeLoc == 'pass') || !isNaN(independant_pass_id)) {
                let passEventIds
                if (event_data?.is_full_season == 0) {
                    passEventIds = JSON.parse(localStorage.getItem('userChooseEvents'))
                } else {
                    passEventIds = event_data?.all_event?.map((item) => item?.id)
                }
                console.log(encryptCardData)
                finalPayload = {
                    'multi_facility_id': linkFacilityId ? linkFacilityId : '',
                    'facility_id': eventFacilityid,
                    'name': name,
                    'phone': phone,
                    'email': email,
                    'total': sessionDetails?.data?.amount,
                    'rate_id': independant_pass_id ? independant_pass_id : get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                    'event_id': '',
                    'event_category_id': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.event_category_event?.event_category_id : event_data?.event_category_id,
                    // 'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event?.[0]?.start_time,
                    'arrival': isParkingStartPassed ? currentTime : ((get_event_type == EVENT_TYPES?.EVENT) ? event_data?.parking_start_time : event_data?.all_event?.[0]?.parking_start_time),
                    'event_type': independant_pass_id ? EVENT_TYPES?.SIMPLE : get_event_type,
                    'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                    'reference': sessionDetails?.data?.reference,
                    'ex_month': card_date_expiry_month,
                    'ex_year': card_date_expiry_year,
                    'user_consent': (user_consent) ? user_consent : '0',
                    'nonce': encryptCardData,
                    'event_ids': passEventIds,
                    'is_booking_direct': (payment_detail) ? '0' : '1',
                    'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                    'user_id': (isUserLoggedIn()) ? userDetails?.id : '',
                    'payment_profile_id': (payment_profile_id) ? payment_profile_id : '',
                    'pass_start_date': event_data?.start_date ? event_data?.start_date : '',
                    'pass_end_date': event_data?.end_date ? event_data?.end_date : '',
                    'booking_label_id': partnerDetails?.id ? partnerDetails?.id : '',
                }
            } else {
                console.log(encryptCardData)
                finalPayload = {
                    'multi_facility_id': linkFacilityId ? linkFacilityId : '',
                    'facility_id': eventFacilityid,
                    'name': name,
                    'phone': phone,
                    'email': email,
                    'total': sessionDetails?.data?.amount,
                    'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                    'event_id': get_event_type == EVENT_TYPES?.EVENT ? event_data?.id : '',
                    // 'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event?.[0]?.start_time,
                    'arrival': isParkingStartPassed ? currentTime : ((get_event_type == EVENT_TYPES?.EVENT) ? event_data?.parking_start_time : event_data?.all_event?.[0]?.parking_start_time),
                    'event_type': get_event_type,
                    'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                    'user_consent': (user_consent) ? user_consent : '0',
                    'nonce': encryptCardData,
                    'payment_profile_id': (payment_profile_id) ? payment_profile_id : '',
                    'is_booking_direct': (payment_detail) ? '0' : '1',
                    'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                    'user_id': (isUserLoggedIn()) ? userDetails?.id : '',
                    'pass_start_date': event_data?.start_date ? event_data?.start_date : '',
                    'pass_end_date': event_data?.end_date ? event_data?.end_date : '',
                    'booking_label_id': partnerDetails?.id ? partnerDetails?.id : '',
                }
            }

            if (vehicle_details?.vehicle_id && vehicle_details?.license_plate) {
                finalPayload.vehicle_id = vehicle_details?.vehicle_id
                finalPayload.license_plate = vehicle_details?.license_plate
            }
            if (vehicle_details?.license_plate && !vehicle_details?.vehicle_id) {
                finalPayload.license_plate = vehicle_details?.license_plate
                finalPayload.color = vehicle_details?.color
                finalPayload.make = vehicle_details?.make_id ? '' : (vehicle_details?.make == 'Others' ? vehicle_details?.make_other : vehicle_details?.make)
                finalPayload.model = vehicle_details?.model_id ? '' : ((vehicle_details?.make == 'Others' || vehicle_details?.model == 'Others') ? vehicle_details?.model_other : vehicle_details?.model)
                finalPayload.country = vehicle_details?.country
                finalPayload.state_id = vehicle_details?.state_id
                finalPayload.color_id = vehicle_details?.color_id
                finalPayload.make_id = vehicle_details?.make_id
                finalPayload.model_id = vehicle_details?.model_id
                finalPayload.vehicle_type_id = vehicle_details?.vehicle_type_id
                finalPayload.vehicle_type = vehicle_details?.vehicle_type
            }
            finalPayload.amenities = Array.isArray(bookingData?.amenities) ? bookingData?.amenities : []
            if (sessionDetails?.data?.discounted_amount > 0) {
                finalPayload.discount_amount = sessionDetails?.data?.discounted_amount
            }
            if (isUserLoggedIn()) {
                finalPayload.card_last_four = selectedCard?.card_last_four ? selectedCard?.card_last_four : ''
                finalPayload.expiry = selectedCard?.expiry ? selectedCard?.expiry : ''
            }
            if (sessionDetails?.data?.new_parking_amount) {
                finalPayload.new_parking_amount = sessionDetails?.data?.new_parking_amount
            }
            if (sessionDetails?.data?.new_tax_rate) {
                finalPayload.new_tax_rate = sessionDetails?.data?.new_tax_rate
            }
            if (sessionDetails?.data?.new_processing_fee) {
                finalPayload.new_processing_fee = sessionDetails?.data?.new_processing_fee
            }
            // The payment from the payment modal
            if (payment?.kind) {
                finalPayload.is_booking_direct = '0'
            }
            if (payment?.kind === 'verify') {
                // Wallets: the booking is checked first, nothing is charged
                finalPayload.verify_prepay = '1'
            } else if (payment?.kind === 'token') {
                // Stripe / Datacap / Heartland card fields: the token, with the name on the card and billing zip
                Object.assign(finalPayload, hostedCardTokenFields(paymentFacility, payment.token))
                finalPayload.name_on_card = cardForm?.name_on_card?.trim() || ''
                finalPayload.zip_code_on_card = cardForm?.zip_code || ''
                finalPayload.nonce = ''
                finalPayload.payment_profile_id = ''
                finalPayload.user_consent = saveCard ? '1' : '0'
            } else if (payment?.kind === 'nonce') {
                // Fiserv (CardConnect token) / card form
                finalPayload.nonce = payment.nonce
                finalPayload.payment_profile_id = ''
                finalPayload.user_consent = saveCard ? '1' : '0'
            } else if (payment?.kind === 'saved') {
                finalPayload.nonce = ''
                finalPayload.payment_profile_id = payment.card?.payment_profile_id || ''
                finalPayload.card_last_four = payment.card?.card_last_four || ''
                finalPayload.expiry = payment.card?.expiry || ''
                finalPayload.user_consent = '0'
            } else if (payment?.kind === 'wallet') {
                finalPayload.nonce = ''
                finalPayload.payment_profile_id = ''
                finalPayload.paymentMethods = payment.data?.paymentMethods
                finalPayload.walletPay = payment.data?.walletPay
                if (payment.data?.transaction_id) {
                    finalPayload.transaction_id = payment.data?.transaction_id
                }
                finalPayload.verify_prepay = '0'
            }

            let selectEventTypeData = localStorage.getItem('selectEventType')

            if (isBookingClosedCheck && selectEventTypeData != 'pass') {
                setLocalIsBookingClosed(isBookingClosedCheck)
                notify('error', errorMessages?.soldOutError)
            } else {
                submittingRef.current = true
                setIsSubmitting(true)
                captchaService.execute('checkout').then((recaptcha_token) => {
                    if (!recaptcha_token) {
                        throw new Error('reCAPTCHA did not return a token.')
                    }
                    finalPayload.recaptcha_token = recaptcha_token
                    return dispatch(dynamicPaymentGateByNonce(finalPayload))
                }).then((res) => {
                    APILoad.current = true
                    // Wallets: the booking was checked, now the modal opens for the payment
                    if (payment?.kind === 'verify') {
                        submittingRef.current = false
                        setIsSubmitting(false)
                        if (res?.data) {
                            setIsPaymentModalOpen(true)
                        } else {
                            notify('error', res?.errors?.message || errorMessages?.somethingWentWrong)
                        }
                        return
                    }
                    // Stripe: the bank asked for 3DS -> authenticate, then pay once more with pi_ (once)
                    const stripeAction = (payment?.kind === 'token' && isStripeGateway(paymentFacility)) ? getStripeRequiredAction(res, finalPayload) : null
                    if (stripeAction) {
                        completeStripeRequiredAction(stripeAction, paymentFacility).then(({ error, token }) => {
                            submittingRef.current = false
                            setIsSubmitting(false)
                            if (error) {
                                notify('error', getStripeErrorMessage(error))
                                return
                            }
                            onClickSubmit({ kind: 'token', token })
                        })
                        return
                    }
                    closeApplePaySession(res?.data ? 'success' : 'failed')
                    if (res?.data) {
                        if (isUserLoggedIn()) {
                            let userData = JSON.parse(localStorage.getItem('userData'))
                            userData.user.phone = phone
                            userData.user.phone_number = phone
                            localStorage.setItem('userData', JSON.stringify(userData))
                        }
                        if (facility && !event_id) {
                            navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_SUCCESS1}`)
                        } else {
                            navigate(`/${partnername?.[0]}/${URL?.PAYMENT_SUCCESS1}`)
                        }
                        localStorage.setItem('paymentResponse', JSON.stringify(res?.data))
                    } else {
                        if (facility && !event_id) {
                            navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_FAIL2}`)
                        } else {
                            navigate(`/${partnername?.[0]}/${URL?.PAYMENT_FAIL2}`)
                        }
                        localStorage.setItem('paymentResponse', JSON.stringify(res))
                    }
                }).catch((error) => {
                    APILoad.current = true
                    closeApplePaySession('failed')
                    submittingRef.current = false
                    setIsSubmitting(false)
                    notify('error', error?.message || errorMessages?.somethingWentWrong)
                })
            }
        }
    }



    // ---- Payment modal (as the other portals): Proceed To Pay -> New Card / Saved Card / Apple Pay - GPay; the
    // payment itself is onClickSubmit(payment)
    // The facility saved by the booking page; else the event's facility (pass: passData) as onClickSubmit reads it
    const paymentFacility = useMemo(() => {
        if (bookingData?.payment_facility?.facility_payment_details?.facility_payment_type_id) {
            return bookingData.payment_facility
        }
        try {
            const eventFacilityid = (facility ? facility : getLocalFacilityId()) || selectedFacilityId
            const linkFacility = localStorage.getItem('selectEventType') == 'pass'
                ? JSON.parse(localStorage.getItem('passData') || '{}')?.facility
                : JSON.parse(localStorage.getItem('selectEventLinkFacility') || '[]')?.find?.((v) => v?.id == eventFacilityid)
            return linkFacility || EMPTY_OBJECT
        } catch (e) {
            return EMPTY_OBJECT
        }
    }, [bookingData?.payment_facility, facility, selectedFacilityId])

    const paymentGateway = String(paymentFacility?.facility_payment_details?.facility_payment_type_id || '')
    const isFiservGateway = paymentGateway === PAYMENT_GATEWAY.FISERV
    const paymentAmount = Number(sessionDetails?.data?.amount)
    const paymentModalFlow = paymentAmount > 0 && !payment_detail
    const walletEnabled = !!bookingData?.wallet_enabled
    const isIOSDevice = getDeviceType()
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
    const [paymentTab, setPaymentTab] = useState(null)
    const [cardForm, setCardForm] = useState({ name_on_card: name || '', card_number: '', card_expiry: '', cvv: '', zip_code: '' })
    const [showCardErrors, setShowCardErrors] = useState(false)
    const [saveCard, setSaveCard] = useState(false)
    const [savedCardId, setSavedCardId] = useState(selectedCard?.payment_profile_id || '')
    // Fiserv (CardConnect iframe) token / error, read after waiting for the iframe's answer
    const fiservTokenRef = useRef(null)
    const iframeErrorRef = useRef('')
    const [iframeError, setIframeError] = useState('')
    // false while a gateway token is being sent; true lets the gateway's card fields send the next one
    const APILoad = useRef(true)
    const applePaySessionRef = useRef(null)
    const scriptsLoaded = useRef()

    // Datacap / Heartland card field and wallet scripts of the gateway
    useEffect(() => {
        if (!paymentGateway) return
        Object.values(getWalletScriptUrl(paymentGateway) || {}).map((item) => {
            if (item) {
                addScript(scriptsLoaded, item, '')
            }
        })
    }, [paymentGateway])

    const closeApplePaySession = (endsession) => {
        if (applePaySessionRef.current) {
            if (endsession === 'success') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            } else {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
            }
            applePaySessionRef.current = null
        }
    }

    // Wallets: the booking is checked first (verify_prepay), then the modal opens
    const handleProceedToPay = () => {
        if (walletEnabled) {
            onClickSubmit({ kind: 'verify' })
            return
        }
        setIsPaymentModalOpen(true)
    }

    // Closing the modal drops the card / token entered there, so nothing is paid with it later
    const closePaymentModal = () => {
        if (submittingRef.current) return
        fiservTokenRef.current = null
        iframeErrorRef.current = ''
        setIframeError('')
        setShowCardErrors(false)
        setPaymentTab(null)
        setIsPaymentModalOpen(false)
    }

    const handleCardField = (key, value) => setCardForm((prev) => ({ ...prev, [key]: value }))
    const cardHolderOk = () => {
        setShowCardErrors(true)
        return !!cardForm?.name_on_card?.trim()
    }

    // The gateway's card fields (Stripe / Datacap / Heartland) gave the token
    const handleGatewayToken = (data) => {
        const token = data?.paymentToken?.Token ? data.paymentToken : null
        if (!token || !cardHolderOk()) {
            APILoad.current = true
            return
        }
        onClickSubmit({ kind: 'token', token })
    }

    // Fiserv: pressing Pay blurs the card iframe, which answers (token / validation error) a moment later
    const handleFiservPay = async () => {
        await waitForCardTokenizer()
        const cardToken = fiservTokenRef.current
        const token = cardToken?.message || cardToken?.token
        if (iframeErrorRef.current) {
            notify('error', iframeErrorRef.current)
            return
        }
        if (!cardHolderOk()) return
        if (!token) {
            notify('error', 'Please complete card information in the form above.')
            return
        }
        // Nonce fields in the backend's order; expiry as YYYY/MM
        onClickSubmit({
            kind: 'nonce',
            nonce: encryptionHandler({
                name_on_card: cardForm.name_on_card.trim(),
                card_number: token,
                expiration_date: formatYearMonthExpiry(cardToken?.expiry),
                security_code: '',
                zip_code: cardForm.zip_code || ''
            })
        })
    }

    // Card form (no gateway card fields: Datatrans, or Datacap / Heartland with the iframe turned off)
    const handleCardFormPay = () => {
        setShowCardErrors(true)
        const cardNumber = (cardForm.card_number || '').replace(/\D/g, '')
        const expiry = (cardForm.card_expiry || '').replace(/\D/g, '')
        if (!cardForm.name_on_card?.trim() || cardNumber.length < 15 || expiry.length != 4 || !validExpiryDate(expiry) || !(cardForm.cvv?.length >= 3)) {
            return
        }
        onClickSubmit({
            kind: 'nonce',
            nonce: encryptionHandler({
                name_on_card: cardForm.name_on_card.trim(),
                card_number: cardNumber,
                expiration_date: expiry,
                security_code: cardForm.cvv,
                zip_code: cardForm.zip_code || ''
            })
        })
    }

    const handleSavedCardPay = () => {
        const card = cardList?.find((item) => item?.payment_profile_id == savedCardId)
        if (!card) {
            notify('error', 'Please select a card.')
            return
        }
        onClickSubmit({ kind: 'saved', card })
    }

    // Apple Pay / Google Pay buttons call onSubmit as (data) or (data, 0)
    const handleWalletSubmit = (...args) => {
        const data = args.find((arg) => arg && typeof arg === 'object' && arg.walletPay !== undefined)
        if (data) {
            onClickSubmit({ kind: 'wallet', data })
        }
    }

    // New Card: the saved-card id is not used; Saved Card: the selected (or default) card
    const handlePaymentTabChange = (method) => {
        setPaymentTab(method)
        if (method == 'saved-card' && !savedCardId) {
            const card = cardList?.find((item) => item?.is_default == '1') || cardList?.[0]
            if (card) setSavedCardId(card?.payment_profile_id)
        }
    }

    const payButton = (onClick) => (
        <Button variant="primary" type='button' className="btn btn-primary w-100 mt-3 d-flex align-items-center justify-content-center" onClick={onClick} disabled={isSubmitting}>
            <span className='fw-bold'>Pay</span>
            {isSubmitting ? <span className='ms-2'><Circles height="20" width="20" color="#ffffff" ariaLabel="circles-loading" visible={true} /></span> : null}
        </Button>
    )
    const amountDueRow = (
        <div className='d-flex justify-content-between align-items-center py-2 border-top border-bottom mt-3 mb-2'>
            <span className='fw-semibold'>Amount Due</span>
            <span className='fw-bold'>${getFormattedAmountNumber(paymentAmount)}</span>
        </div>
    )
    // Card holder fields in the same order for every form (as the other portals): name, card, zip
    const nameOnCardField = (
        <div className="mb-3">
            <label className="form-label">Name on Card <span className='text-danger'>*</span></label>
            <input type="text" className="form-control" autoComplete="off" maxLength={50} placeholder="Name on Card"
                value={cardForm.name_on_card} onChange={(e) => handleCardField('name_on_card', e.target.value)} />
            {showCardErrors && !cardForm.name_on_card?.trim() ? <span className="form-text text-danger">This field is required</span> : null}
        </div>
    )
    const zipCodeField = (
        <div className="mb-3">
            <label className="form-label">Zip Code</label>
            <input type="text" className="form-control" autoComplete="off" maxLength={6} placeholder="Billing Address Zip Code"
                value={cardForm.zip_code} onKeyPress={(e) => restrictInputValues(e)} onChange={(e) => handleCardField('zip_code', e.target.value)} />
            <span className="form-text text-danger">**Mandatory for Amex Cards only</span>
        </div>
    )
    const saveCardField = isUserLoggedIn() ? (
        <div className="form-check mb-2">
            <input className="form-check-input" type="checkbox" id="saveCardConsent" checked={saveCard} onChange={() => setSaveCard(!saveCard)} />
            <label className="form-check-label" htmlFor="saveCardConsent">Save the card</label>
        </div>
    ) : null
    const cardFormFields = (
        <>
            <div className="mb-3">
                <label className="form-label">Card Number <span className='text-danger'>*</span></label>
                <MaskedInput maskGenerator={cardNumberMask} className="form-control" autoComplete="off" placeholder="Card Number"
                    value={cardForm.card_number} onChange={(value) => handleCardField('card_number', value)} />
                {showCardErrors && (cardForm.card_number || '').replace(/\D/g, '').length < 15 ? <span className="form-text text-danger">Please enter a valid card number</span> : null}
            </div>
            <div className="row">
                <div className="col-6 mb-3">
                    <label className="form-label">Expiry Date <span className='text-danger'>*</span></label>
                    <MaskedInput maskGenerator={cardExpiryMask} className="form-control" autoComplete="off" placeholder="MM/YY"
                        value={cardForm.card_expiry} onChange={(value) => handleCardField('card_expiry', value)} />
                    {showCardErrors && !validExpiryDate((cardForm.card_expiry || '').replace(/\D/g, '')) ? <span className="form-text text-danger">Please enter a valid expiry date</span> : null}
                </div>
                <div className="col-6 mb-3">
                    <label className="form-label">CVV <span className='text-danger'>*</span></label>
                    <input type="password" className="form-control" autoComplete="off" maxLength={4} placeholder="CVV"
                        value={cardForm.cvv} onKeyPress={(e) => restrictInputValues(e)} onChange={(e) => handleCardField('cvv', e.target.value)} />
                    {showCardErrors && !(cardForm.cvv?.length >= 3) ? <span className="form-text text-danger">This field is required</span> : null}
                </div>
            </div>
        </>
    )

    // New Card tab by gateway: the gateway's card fields (own Submit), Fiserv's CardConnect fields or the card form
    const newCardForm = usesHostedCardFields(paymentFacility) ? (
        <>
            {nameOnCardField}
            <PaymentGatewayCommon
                faciltyData={paymentFacility}
                onSubmit={handleGatewayToken}
                isSubmittingForm={isSubmitting}
                setIsSubmittingForm={noop}
                setFormData={noop}
                formData={EMPTY_OBJECT}
                setValue={noop}
                previousButton={<></>}
                customGateWay={<></>}
                page='permit'
                amount={paymentAmount}
                APILoad={APILoad}
                // Save the card: the Stripe card is kept for later payments (the backend sets the same)
                setupFutureUsage={saveCard ? 'off_session' : null}
                // Same capture_method as the backend's PaymentIntent for event-booking-web (a token made for another one is rejected)
                stripeCaptureMethod={STRIPE_CAPTURE.SALE}
                // Stripe card fields invalid: the name on card is checked with them
                onInvalid={() => setShowCardErrors(true)}
                consent={<>{zipCodeField}{saveCardField}</>}
            />
        </>
    ) : isFiservGateway ? (
        <>
            {nameOnCardField}
            <CardConnectTokenizer
                setToken={(data) => { fiservTokenRef.current = data }}
                faciltyPaymentDetails={paymentFacility?.facility_payment_details}
                setIframeErrorMessage={(message) => { iframeErrorRef.current = message; setIframeError(message) }}
            />
            {iframeError ? <span className="form-text text-danger d-block mb-2">{iframeError}</span> : null}
            {zipCodeField}
            {saveCardField}
            {payButton(handleFiservPay)}
        </>
    ) : (
        <>
            {nameOnCardField}
            {cardFormFields}
            {zipCodeField}
            {saveCardField}
            {payButton(handleCardFormPay)}
        </>
    )
    const newCardContent = (
        <div className='pm-gateway'>
            <p className='mb-2 text-muted small'>Enter Payment Details</p>
            {amountDueRow}
            {newCardForm}
        </div>
    )
    const savedCardContent = (isUserLoggedIn() && cardList?.length > 0) ? (
        <div className='p-2'>
            <span className='fw-semibold'>Select a saved card</span>
            <div className='mt-2 border rounded'>
                {cardList?.map((item, index) => (
                    <div key={index} role='button' style={{ cursor: 'pointer' }}
                        className={`d-flex align-items-center px-3 py-2 ${index < cardList.length - 1 ? 'border-bottom' : ''}`}
                        onClick={() => setSavedCardId(item?.payment_profile_id)}>
                        <i className='fa fa-check me-3' style={{ visibility: savedCardId == item?.payment_profile_id ? 'visible' : 'hidden' }}></i>
                        <i className='fa fa-credit-card me-2 text-muted'></i>
                        <div className='me-auto'>
                            <div className='fw-semibold' style={{ fontSize: '14px' }}>Card ending in {item?.card_last_four?.slice(0, 4)}</div>
                            <div className='text-muted small'>Expires {item?.expiry ? `${item?.expiry?.slice(0, 2)}/${item?.expiry?.slice(2, 4)}` : '--'}</div>
                        </div>
                        {item?.is_default == '1' ? <small className='text-success'>Default</small> : null}
                    </div>
                ))}
            </div>
            {amountDueRow}
            {payButton(handleSavedCardPay)}
        </div>
    ) : null
    const walletContent = walletEnabled ? (
        <div className='d-flex justify-content-center'>
            <div className='position-relative'>
                {isSubmitting ? <div className='overlay-opacity'>&nbsp;</div> : null}
                <WalletButtons
                    faciltyData={paymentFacility}
                    getValues={() => ({ name, email, phone })}
                    onSubmit={handleWalletSubmit}
                    isSubmittingForm={isSubmitting}
                    setIsSubmittingForm={setIsSubmitting}
                    setIsLoading={setIsSubmitting}
                    payableAmount={paymentAmount}
                    notify={notify}
                    isIOSDevice={isIOSDevice}
                    applePaySessionRef={applePaySessionRef}
                    dispatch={dispatch}
                />
            </div>
        </div>
    ) : null
    const currentSelCard = cardList?.find((item) => item?.payment_profile_id == savedCardId)

    return (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <div className="col">
                        <div className="d-flex mb-3 align-items-center ">
                            <label ><b>Personal  Information</b></label>
                            <CommonBtn onClick={prevFormStep} isIconBtn className="btn btn-sm ms-3 p-0" icon={<i className="fa fa-pencil" aria-hidden="true"></i>} />
                        </div>
                        <p><b>{name}</b><br /> {email}<br /> {phone_number} </p>
                    </div>
                    {((payment_detail?.card_date_expiry_month && payment_detail?.card_date_expiry_year) || selectedCard) && <div className="col">
                        <div className="d-flex mb-3  align-items-center ">
                            <label ><b>Payment Details</b></label>
                            <CommonBtn onClick={prevFormStep} isIconBtn className="btn btn-sm ms-3 p-0" icon={<i className="fa fa-pencil" aria-hidden="true"></i>} />
                        </div>
                        <p><i className="fa fa-credit-card" aria-hidden="true"></i> {card} <span className="ms-4"><i className="fa fa-calendar" aria-hidden="true"></i>   {(card_date_expiry_month && card_date_expiry_year) ? card_date_expiry_month + '/' + card_date_expiry_year : selectedCard.expiry}</span> </p>
                    </div>}
                    {(vehicle_details?.license_plate) && <div className="col">
                        <div className="d-flex mb-3  align-items-center ">
                            <label ><b>Vehicle Details</b></label>
                        </div>
                        <p><i className="fa fa-car" aria-hidden="true"></i>   {vehicle_details?.license_plate}</p>
                    </div>}
                </div>
                {isBookingDataMissing && <div className="alert alert-danger py-2" role="alert">
                    {errorMessages?.eventSessionExpired} <button type="button" className="btn btn-link p-0 align-baseline" onClick={() => window.location.reload()}>Reload</button>
                </div>}
                {/* Amount due: Proceed To Pay opens the payment modal; otherwise Confirm & Book as before */}
                <Button variant="primary" type='button' className="btn btn-primary btn" onClick={paymentModalFlow ? handleProceedToPay : () => onClickSubmit()} disabled={(isLoader || localIsBookingClosed || isSubmitting || isBookingDataMissing) ? true : false}>
                    <div className='d-flex justify-content-center align-items-center' disabled={(isLoader) ? true : false}>
                        <span>{localIsBookingClosed ? 'Sold Out' : paymentModalFlow ? 'Proceed To Pay' : ((payment_detail && Number(sessionDetails?.data?.amount) > 0) ? 'Confirm & Pay' : 'Confirm & Book')}</span>  <span>
                            {isLoader ? <Circles
                                height="20"
                                width="20"
                                style={{ display: 'inline-block' }}
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                            /> : null}
                        </span>
                    </div>
                </Button>
                <CommonBtn className="btn btn-secondary ms-1" onClick={prevFormStep} value='Cancel' />
                {paymentModalFlow && <PaymentMethodModal
                    show={isPaymentModalOpen}
                    onHide={closePaymentModal}
                    isPaymentLocked={isSubmitting}
                    isSubmitting={isSubmitting}
                    paybyCardorWallet={true}
                    tab={paymentTab}
                    onTabChange={handlePaymentTabChange}
                    currentSelCard={currentSelCard}
                    amount={paymentAmount}
                    cardContent={newCardContent}
                    savedCardContent={savedCardContent}
                    // Apple Pay / Google Pay tab: by the facility configuration (as the details page)
                    walletButtonShow={walletContent ? true : false}
                    showApplePayButton={paymentFacility?.facility_configuration?.show_apple_pay_button}
                    showGooglePayButton={paymentFacility?.facility_configuration?.show_google_pay_button}
                    isIOSDevice={isIOSDevice}
                    walletContent={walletContent}
                />}
            </div>
        </div>
    )
}

ConfirmationPage.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    nextFormStep: PropTypes.func,
    bookingFormDetail: PropTypes.object,
    prevFormStep: PropTypes.number,
    isLoader: PropTypes.bool,
    userDetails: PropTypes.object,
    selectedFacilityId: PropTypes.string,
    selectedCard: PropTypes.string,
    paybaleAmount: PropTypes.string,
    allFacility: PropTypes.array,
    cardToken: PropTypes.object,
    iframeErrorMsg: PropTypes.string,
    tokenRef: PropTypes.object,
    cardList: PropTypes.array,
}

ConfirmationPage.defaulProps = {
    dispatch: noop,
    notify: noop,
    nextFormStep: noop,
    bookingFormDetail: EMPTY_OBJECT,
    prevFormStep: 0,
    isLoader: false,
    userDetails: EMPTY_OBJECT,
    selectedFacilityId: '',
    selectedCard: '',
    paybaleAmount: '',
    allFacility: EMPTY_ARRAY,
    cardToken: EMPTY_OBJECT,
    iframeErrorMsg: undefined,
    tokenRef: EMPTY_OBJECT,
}


function mapStateToProps({ globalReducers, bookingReducer, loginReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        selectedEventId: globalReducers?.selectedEventId,
        bookingFormPage: globalReducers?.bookingFormPage,
        bookingFormDetail: globalReducers?.bookingFormDetail,
        isLoader: bookingReducer?.loader,
        userDetails: (Object.keys(globalReducers?.userDetails).length > 0) ? globalReducers?.userDetails : loginReducer?.data?.data?.user,
        selectedFacilityId: globalReducers?.selectedFacilityId,
        selectedCard: globalReducers?.selectedCard,
        cardList: (bookingReducer?.cardDetails?.length) ? bookingReducer?.cardDetails : EMPTY_ARRAY,
    }
}

export default connect(mapStateToProps)(ConfirmationPage)